import { FC } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { GroupWrap } from 'src/components/group-wrap';
import { ActiveSection } from 'src/components/header/types';
import { ExternalLink, Link } from 'src/components/link';
import { useBreakpoints } from 'src/hooks/use-breakpoints';
import { LoginResult } from 'src/hooks/use-login';
import { useOptionalMonolithCurrentUser } from 'src/hooks/use-monolith-user';
import { isLng } from 'src/utils/is-lng';

const angularRoutes = ['#/lng'];

export const isLngActive = (
  pathname: string,
  hash: string,
  auth: LoginResult | null
) =>
  // for LNG Operators some paths live in the LNG section
  (auth?.role === 'SSO_ADMIN' &&
    isLng(auth) &&
    Boolean(
      matchPath(pathname, { path: '/shippers' }) ||
        matchPath(pathname, { path: '/dashboard' }) ||
        matchPath(pathname, { path: '/settings/registration' })
    )) ||
  (pathname.startsWith('/platform') &&
    angularRoutes.some((angularRoute) => hash.startsWith(angularRoute)));

export const SecondaryNavLng: FC<{ activeSection: ActiveSection }> = ({
  activeSection,
}) => {
  const { hash, pathname } = useLocation();
  const auth = useOptionalMonolithCurrentUser();
  const { minTablet } = useBreakpoints();

  if (!activeSection.lng) return null;

  return (
    <GroupWrap
      gap={2}
      data-testid="secondary-nav"
      alignItems={!minTablet ? 'stretch' : 'center'}
      flexDirection={!minTablet ? 'column' : 'row'}
    >
      {(auth?.role === 'SHIPPER_USER' || auth?.role === 'SHIPPER_ADMIN') && (
        <>
          <ExternalLink
            mode="secondary"
            href={`${PRISMA_CONFIG.oldFrontendUrl}/#/lng/offers`}
          >
            Auctions
          </ExternalLink>

          {/* <ExternalLink
            mode="secondary"
            href={`${PRISMA_CONFIG.oldFrontendUrl}/#/lng/booking`}
          >
            FCFS Booking
          </ExternalLink> */}
        </>
      )}

      {auth?.role === 'SSO_ADMIN' && (
        <>
          <ExternalLink
            mode="secondary"
            href={`${PRISMA_CONFIG.oldFrontendUrl}/#/lng/offers`}
            isActive={
              hash.startsWith('#/lng/offers') &&
              !hash.startsWith('#/lng/offers/create')
            }
          >
            Manage Offer
          </ExternalLink>

          <ExternalLink
            mode="secondary"
            href={`${PRISMA_CONFIG.oldFrontendUrl}/#/lng/offers/create`}
          >
            Create Offer
          </ExternalLink>

          <Link
            mode="secondary"
            to="/shippers"
            isActive={
              pathname.startsWith('/shippers') ||
              pathname.startsWith('/dashboard/shippers')
            }
          >
            Shippers
          </Link>

          <ExternalLink
            mode="secondary"
            href={`${PRISMA_CONFIG.oldFrontendUrl}/#/lng/settings`}
            isActive={pathname.startsWith('/settings/registration')}
          >
            Settings
          </ExternalLink>

          <ExternalLink
            mode="secondary"
            href={`${PRISMA_CONFIG.oldFrontendUrl}/#/lng/locations`}
          >
            Locations
          </ExternalLink>
        </>
      )}
    </GroupWrap>
  );
};
